import { Share } from '@cube3/common/model/schema/resources/share';
import { generatePath } from 'react-router-dom';
import {
  urlStructureFileRequest,
  urlStructureReview,
  urlStructureReviewLink,
  urlStructureReviewLinkAsset,
  urlStructureReviewLinkComment,
  urlStructureShareLink
} from '../../../routing/routingPaths';

export const getSharePath = (
  share: Share,
  assetId: string,
  commentId?: string
) => {
  const path = (() => {
    if (!share) {
      return '';
    }
    const token = share.token;
    if (!token) return '';
    switch (share.intent) {
      case 'share':
        return generatePath(urlStructureShareLink, { linkHash: token });

      case 'request':
        return generatePath(urlStructureFileRequest, { linkHash: token });

      case 'review':
        return commentId
          ? generatePath(urlStructureReviewLinkComment, {
              token,
              assetId,
              commentId
            })
          : assetId
          ? generatePath(urlStructureReviewLinkAsset, {
              token,
              assetId
            })
          : generatePath(urlStructureReview, { token: token });

      case 'review-legacy':
        return generatePath(urlStructureReviewLink, { linkHash: token });

      default:
        return '';
    }
  })();

  return path;
};
